/*eslint-disable*/
import * as types from './../mutation-types'

const state = {
  intermediateStage: null,
  olympiad: null
};


const mutations = {
  [types.SET_INTERMEDIATE_STAGE](state, intermediateStage) {
    state.intermediateStage = intermediateStage;
  },
  [types.SET_OLYMPIAD](state, olympiad) {
    state.olympiad = olympiad
  }
};

const actions = {
  setOlympiad({commit, state}, olympiad) {
    commit(types.SET_OLYMPIAD, olympiad);
  },
  setIntermediateStage({commit, state}, intermediateStage) {
    commit(types.SET_INTERMEDIATE_STAGE, intermediateStage);
  }
};

export default {
  state,
  mutations,
  actions
}